"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metricsDefault = void 0;

var _aggregator = require("./aggregator.js");

var _exports = require("./exports.js");

/**
 * Adds a value to a counter metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */
function increment(name, value = 1, data) {
  // eslint-disable-next-line deprecation/deprecation
  _exports.metrics.increment(_aggregator.MetricsAggregator, name, value, data);
}
/**
 * Adds a value to a distribution metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function distribution(name, value, data) {
  // eslint-disable-next-line deprecation/deprecation
  _exports.metrics.distribution(_aggregator.MetricsAggregator, name, value, data);
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function set(name, value, data) {
  // eslint-disable-next-line deprecation/deprecation
  _exports.metrics.set(_aggregator.MetricsAggregator, name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function gauge(name, value, data) {
  // eslint-disable-next-line deprecation/deprecation
  _exports.metrics.gauge(_aggregator.MetricsAggregator, name, value, data);
}
/**
 * Adds a timing metric.
 * The metric is added as a distribution metric.
 *
 * You can either directly capture a numeric `value`, or wrap a callback function in `timing`.
 * In the latter case, the duration of the callback execution will be captured as a span & a metric.
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function timing(name, value, unit = 'second', data) {
  // eslint-disable-next-line deprecation/deprecation
  return _exports.metrics.timing(_aggregator.MetricsAggregator, name, value, unit, data);
}
/**
 * Returns the metrics aggregator for a given client.
 */


function getMetricsAggregatorForClient(client) {
  // eslint-disable-next-line deprecation/deprecation
  return _exports.metrics.getMetricsAggregatorForClient(client, _aggregator.MetricsAggregator);
}
/**
 * The metrics API is used to capture custom metrics in Sentry.
 *
 * @deprecated The Sentry metrics beta has ended. This export will be removed in a future release.
 */


const metricsDefault = exports.metricsDefault = {
  increment,
  distribution,
  set,
  gauge,
  timing,

  /**
   * @ignore This is for internal use only.
   */
  getMetricsAggregatorForClient
};